<div class="row">
    <div class="col-md-8 instance-title">
        <h3>{{ 'SELECT_INSTANCE.TITLES.SELECT_INSTANCE' | transloco }}</h3>
    </div>
    <div class="col-md-4 text-end">
        <h3 class="organization_title mt-5">
            Organization Name <span>{{ selectedOrgName }}</span>
        </h3>
    </div>
</div>

<div>
    <div class="row">
        <div class="col-md-8 instance-title"></div>
        <div class="col-md-4 text-end">
            <div class="search-wrapper">
                <mat-form-field class="mat-filed">
                    <input
                        matInput
                        type="text"
                        placeholder="{{ 'SELECT_ORG_PAGE.LABELS.SEARCH' | transloco }}"
                        (keyup)="searchInstance()"
                        [(ngModel)]="searchInput"
                        autocomplete="off"
                    />
                    <button mat-button matPrefix mat-icon-button class="search_btn">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>

                <button
                    type="button"
                    class="btn secondary-ebtn"
                    *ngIf="isAddEnabled && instanceList.length < instanceLimit"
                    [routerLink]="['/management/add-instance']"
                    [queryParams]="{ organizationId: this.organizationId }"
                >
                    {{ 'SELECT_INSTANCE.LABELS.ADD_INSTANCE' | transloco }}
                </button>
            </div>
        </div>
    </div>
    <div class="org-section-scroll" *ngIf="instances.length > 0">
        <div class="row mt-4 mb-4">
            <div *ngIf="instances" class="organization_container" style="display: contents">
                <div class="col-xl-4 col-lg-4 col-md-4 mt-4 mb-4 px-4" *ngFor="let instance of instances; let i = index">
                    <div
                        class="position-relative"
                        [matTooltip]="'Access to this ' + instance.name + ' has expired. To request an extension, please contact your administrator.'"
                        [matTooltipDisabled]="!disableInstance(instance)"
                        matTooltipPosition="above"
                    >
                        <div
                            class="org-image"
                            style="height: 100px; width: 100px; margin: 0 auto"
                            (click)="!disableInstance(instance) && selectInstance(instance)"
                            [style.cursor]="disableInstance(instance) ? 'default' : 'pointer'"
                        >
                            <img *ngIf="instance.logo" [src]="instance.logo" alt="logo" style="height: 95px; margin-top: 5px" />
                            <!-- <ngx-avatars
                                *ngIf="!instance.logo"
                                [name]="instance.name"
                                initialsSize="3"
                                class="avatar"
                                size="100"
                                bgColor="#ffcc01"
                                fgColor="#010101"
                            ></ngx-avatars> -->
                            <div
                                *ngIf="!instance.logo"
                                class="custom-avatar avatar"
                                [ngStyle]="{
                                    width: '100px',
                                    height: '100px',
                                    backgroundColor: '#ffcc01',
                                    color: '#010101',
                                    fontSize: '32px',
                                }"
                            >
                                {{ getInitials(instance.name) }}
                            </div>
                        </div>
                        <div
                            class="organization_div"
                            id="{{ instance.instanceId }}"
                            (click)="!disableInstance(instance) && selectInstance(instance)"
                            [style.cursor]="disableInstance(instance) ? 'default' : 'pointer'"
                        >
                            <br />
                            <h3>{{ instance.name }}</h3>
                            <hr />

                            <div class="metrics">
                                <div class="metric">
                                    <span>Asset Type</span>
                                    <strong>{{ instance.instanceAssetType.name }}</strong>
                                </div>
                                <div class="metric">
                                    <span>Instance Context</span>
                                    <strong>{{ instance.instanceContext.name }}</strong>
                                </div>
                                <div class="metric">
                                    <span>User(s)</span>
                                    <strong>{{ instance.userCount }}</strong>
                                </div>
                            </div>
                            <div class="edit-icon">
                                <i
                                    class="fa fa-edit edit-icon"
                                    *ngIf="isEditEnabled === true && !disableInstance(instance)"
                                    (click)="navigateInstanceEdit($event, instance.instanceId)"
                                ></i>
                                <i
                                    class="fas fa-eye"
                                    *ngIf="isInstanceView && !isEditEnabled && !disableInstance(instance)"
                                    (click)="navigateInstanceEdit($event, instance.instanceId)"
                                ></i>
                                <i class="fa fa-ban disabled-org-icon" *ngIf="disableInstance(instance)" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="instances.length === 0 && searchInput">
        <p class="no-ins-mesaage">{{ "SELECT_INSTANCE.LABELS.WE_COUNDN'T_FIND_ANY_INSTANCES_FOR" | transloco }} '{{ searchInput }}'</p>
    </div>
    <div *ngIf="instances.length === 0 && !searchInput">
        <p class="no-ins-mesaage">
            {{ 'SELECT_INSTANCE.LABELS.NO_INSTANCE_AVAILABLE_TO_SELECT' | transloco }}
        </p>
    </div>
</div>
